import HttpRoutingService from "../../shared/services/httpRoutingService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProductReportResponse } from "../../components/dashboard/soldProductReport/soldProductReport.module";

type CommonType =
    {
        loading: boolean,
        error: string,
    }

interface intialState {
    getSoldProductReport: CommonType & { value: ProductReportResponse | null, isReached: boolean, filter: string | null },
}

export type discountLogsListPayload =
    {
        offset: number,
        limit: number,
        filterData: any,
    }



const intialState: intialState =
{
    getSoldProductReport: { loading: false, value: null, error: '', isReached: false, filter: null },
}


export const getSoldProductReport = createAsyncThunk('productLogs/getSoldProductReport', ({ storeId, data }: { storeId: number, data: discountLogsListPayload }) => {
    const url = HttpRoutingService.replaceUrl('stores/{storeId}/pos/report/product', { storeId: storeId })
    return HttpRoutingService.getMethod<ProductReportResponse>(url, data)
})

export const soldProductReportSlice = createSlice({
    name: 'productLogs',
    initialState: intialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getSoldProductReport.pending, (state) => {
                state.getSoldProductReport.loading = true
            })
            .addCase(getSoldProductReport.fulfilled, (state, action) => {
                state.getSoldProductReport.loading = false
                let prev = state.getSoldProductReport.value;
                let current = action.payload;
                let combine: ProductReportResponse | null = null
                let offset = action.meta.arg.data.offset
                if (offset > 0) {
                    combine = {
                        message: current?.message ?? prev?.message ?? "",
                        statusCode: current?.statusCode ?? prev?.statusCode ?? "",
                        success: current?.success ?? prev?.success ?? false,
                        productReport: {
                            overallSummary: {
                                ...prev?.productReport?.overallSummary,
                                ...current?.productReport?.overallSummary,
                            },
                            productSummary: [
                                ...(prev?.productReport?.productSummary || []),
                                ...(current?.productReport?.productSummary || []),
                            ],
                            productSummaryCount: current?.productReport?.productSummaryCount || 0
                        },
                    };
                }
                if (current?.productReport?.productSummary?.length < action.meta.arg.data.limit) {
                    state.getSoldProductReport.isReached = true
                }
                else {
                    state.getSoldProductReport.isReached = false
                }
                state.getSoldProductReport.value = offset > 0 ? combine : action.payload
                state.getSoldProductReport.filter = action.meta.arg.data.filterData
            })
            .addCase(getSoldProductReport.rejected, (state, action) => {
                state.getSoldProductReport.loading = false
                state.getSoldProductReport.error = action.error.message as string
            })
    },
})

export default soldProductReportSlice?.reducer